module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-200.woff2?2283a7f9a19a88a65cedff89d15f708b";